import { createContext, type ReactNode, useContext } from 'react';

/**
 * Extra controls every header shows (the app's Help button). The UI kit does not know the
 * app's features; the app provides them once and each shell renders them.
 */
const HeaderActionsContext = createContext<ReactNode>(null);

export const HeaderActionsProvider = HeaderActionsContext.Provider;
export const useHeaderActions = () => useContext(HeaderActionsContext);
